import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Tax } from '../../../models/';
import { SalonService } from '../../../services/salon.service';
import { UserService } from '../../../services/user.service';
import { List } from 'immutable';
import { Router } from '@angular/router'
import { TaxFormComponent } from './tax-form/tax-form.component';
declare var posthog: any;
@Component({
  selector: 'app-taxes',
  templateUrl: './taxes.page.html',
  styleUrls: ['./taxes.page.scss'],
})
export class TaxesPage implements OnInit {

  public isLoading: boolean;

  public errorOccured: boolean;

  public taxes: List<Tax>;

  public taxesCopy;
  constructor (private salonService: SalonService,
               private userService: UserService,
               private modalController: ModalController,
               private ref: ChangeDetectorRef,
               private router: Router
  ) {
    this.taxes=  List([]);
  }


  public ngOnInit () {
    this.loadTaxes();
  }

  private convertRate(){
    this.taxesCopy.forEach((tax) => {
      tax.rateString = (tax.rate*100).toFixed(2) + "%";
    })
  }
  
  public loadTaxes () {
    this.isLoading = true;
    this.errorOccured = false;
    this.salonService.getTaxes(true)
      .subscribe({next: (taxes) => {
          this.taxes = taxes;
          this.taxesCopy = taxes
          this.convertRate()
          this.isLoading = false;
          this.ref.detectChanges();

        },
        error:(err) => {
          this.isLoading = false;
          this.errorOccured = true;
          this.ref.detectChanges();
        }});
  }

  public async onTaxEditHandler (tax: Tax, index: number) {
    const modal = await this.modalController.create({
      component: TaxFormComponent,
      componentProps: {
        tax: tax,
      }
    })
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        if (data.data.action === 'save') {
          this.taxes = this.taxes.set(index, data.data.tax);
          this.taxesCopy = this.taxesCopy.set(index, data.data.tax);
          this.convertRate()
        } else {
          this.taxes = this.taxes.remove(index);
          this.taxesCopy = this.taxesCopy.remove(index);
        }

        this.salonService.updateTaxes(this.taxes);
      }
    });
    modal.present();
  }

  public async createTax () {
    const tax: Tax = new Tax({
      id: undefined,
      name: '',
      rate: 0,
      appliesTo: 2,
      bizNo: '',
      totals: 0
    });
    const modal = await this.modalController.create({
      component: TaxFormComponent,
      componentProps: {
        tax: tax,
      }
    })
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        this.taxes = this.taxes.push(data.data.tax);
        this.taxesCopy = this.taxesCopy.push(data.data.tax);
        this.convertRate()
        this.salonService.updateTaxes(this.taxes);
      }
    });
    modal.present();

  }


}
